export enum E_Locales {
  EN = 'en',
  FR = 'fr'
}

// Full locale codes for internationalization
export const C_FullLocales = {
  [E_Locales.EN]: 'en_US',
  [E_Locales.FR]: 'fr_FR'
} as const;

// Short locale codes for routing
export const C_ShortLocales = {
  [E_Locales.EN]: 'en',
  [E_Locales.FR]: 'fr'
} as const;
